import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';
import { getDeviceGroupId } from 'utils/common/registerDevGroupID';

function getOrganizationGroupThemeByGroup() {
  const group_id = getDeviceGroupId()
  return httpService.get(ApiUrl.ORGANIZATIONGROUPTHEME + '?organization_group_id=' + group_id);
}

const obj = { getOrganizationGroupThemeByGroup };

export default obj;
